/* ============================================================
   MealPrep.nz - menu section behaviour

   Tab filtering, the show-all expander, and the full-screen product
   card. Lives in an asset rather than inline in the section for two
   reasons: it is long, and re-uploading a 9KB section to fix one line
   of script is wasteful.

   It measures nothing, so load order does not matter the way it did
   for mp-reviews-more.js.

   ONE MODAL, FORTY PAYLOADS
   Every card carries a hidden .mp-meal__detail holding its panels.
   The modal clones the panels of whichever card was pressed, so there
   is a single dialog on the page instead of forty.

   The image is CLONED, not rebuilt from a string. The first version
   wrote:

     '<img src="' + img.currentSrc || img.src + '" alt="">'

   which is a precedence trap - the left concat is always truthy, so
   the expression short-circuits to an unterminated tag and the modal
   rendered no image at all.
   ============================================================ */
(function () {

  function filters(root) {
    (root || document).querySelectorAll('[data-mp-tabs]').forEach(function (tabs) {
      if (tabs.dataset.mpReady) return;
      tabs.dataset.mpReady = '1';

      var panel  = tabs.closest('.mp-panel') || tabs.parentElement;
      var grid   = panel.querySelector('[data-mp-meals]');
      var empty  = panel.querySelector('[data-mp-meals-empty]');
      var label  = panel.querySelector('[data-mp-tabs-count]');
      var expand = panel.querySelector('[data-mp-expand]');
      if (!grid) return;

      var bottomTabs = Array.prototype.slice.call(panel.querySelectorAll('[data-mp-tabs-bottom]'));
      var tabSets = [tabs].concat(bottomTabs);
      var cards = Array.prototype.slice.call(grid.querySelectorAll('.mp-meal'));
      var step  = parseInt(grid.dataset.shown, 10) || 8;
      var open  = false;
      var match = '';
      var maxCarbs = null;
      var mobileQuery = window.matchMedia('(max-width: 749px)');
      var previewLimit = parseInt(grid.dataset.previewLimit, 10) || 0;
      var homeOrdering = !!grid.closest('#MainContent[data-template="index"]');

      function visibleLimit() {
        if (homeOrdering) return 10;
        if (previewLimit > 0) return previewLimit;
        if (mobileQuery.matches) return Infinity;
        return step;
      }

      function apply() {
        var terms = (match || '').split(',').map(function (s) { return s.trim(); }).filter(Boolean);
        var limit = visibleLimit();
        var cap = previewLimit > 0 && !homeOrdering ? limit : (open ? Infinity : limit);
        var visible = 0, matched = 0;

        cards.forEach(function (card) {
          var tags = card.getAttribute('data-tags') || '';
          var carbValue = parseFloat(card.getAttribute('data-carbs'));
          var carbHit = maxCarbs === null || (!isNaN(carbValue) && carbValue < maxCarbs);
          var tagHit = terms.length === 0 || terms.some(function (t) { return tags.indexOf(t) !== -1; });
          var hit = tagHit && carbHit;
          if (hit) matched++;
          var show = hit && visible < cap;
          card.hidden = !show;
          if (show) visible++;
        });

        if (empty) empty.hidden = matched !== 0;
        if (label) label.textContent = matched === 0 ? '' : 'Showing ' + visible + ' of ' + matched + ' meal' + (matched === 1 ? '' : 's');

        if (expand) {
          if (matched <= limit) { expand.hidden = true; }
          else { expand.hidden = false; expand.textContent = open ? 'Show fewer' : (homeOrdering ? 'More meals' : 'View all ' + matched + ' meals'); }
          expand.setAttribute('aria-expanded', open ? 'true' : 'false');
        }
      }

      function activate(btn, scrollToResults) {
        var nextMatch = btn.getAttribute('data-match') || '';
        var nextCarbs = btn.getAttribute('data-max-carbs') || '';

        tabSets.forEach(function (tabSet) {
          tabSet.querySelectorAll('.mp-tab').forEach(function (candidate) {
            var on = (candidate.getAttribute('data-match') || '') === nextMatch
              && (candidate.getAttribute('data-max-carbs') || '') === nextCarbs;
            candidate.classList.toggle('is-active', on);
            candidate.setAttribute('aria-selected', on ? 'true' : 'false');
          });
        });

        panel.style.setProperty('--tab-glow', btn.style.getPropertyValue('--tab-glow') || '#C2C15D');
        match = nextMatch;
        maxCarbs = parseFloat(nextCarbs);
        if (isNaN(maxCarbs)) maxCarbs = null;
        open = false;
        apply();

        if (scrollToResults) {
          window.setTimeout(function () {
            var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
            grid.scrollIntoView({ block: 'start', behavior: reducedMotion ? 'auto' : 'smooth' });
          }, 40);
        }
      }

      tabs.addEventListener('click', function (e) {
        var btn = e.target.closest('.mp-tab');
        if (!btn || !tabs.contains(btn)) return;
        activate(btn, false);
      });

      bottomTabs.forEach(function (bottomTabsEl) {
        bottomTabsEl.addEventListener('click', function (e) {
          var btn = e.target.closest('.mp-tab');
          if (!btn || !bottomTabsEl.contains(btn)) return;
          activate(btn, true);
        });
      });

      if (expand) {
        expand.addEventListener('click', function () {
          open = !open;
          apply();
          if (!open) grid.scrollIntoView({ block: 'start', behavior: 'smooth' });
        });
      }

      var first = tabs.querySelector('.mp-tab.is-active') || tabs.querySelector('.mp-tab');
      if (first) activate(first, false);
      else apply();

      if (mobileQuery.addEventListener) {
        mobileQuery.addEventListener('change', function () { open = false; apply(); });
      } else if (mobileQuery.addListener) {
        mobileQuery.addListener(function () { open = false; apply(); });
      }
    });
  }

  function boxGuide(root) {
    var scope = root || document;
    var guides = scope.querySelectorAll ? scope.querySelectorAll('[data-mp-box-guide]') : [];

    Array.prototype.forEach.call(guides, function (guide) {
      if (guide.dataset.mpReady) return;
      guide.dataset.mpReady = '1';

      var panel = guide.closest('.mp-panel') || document;
      var menuSection = guide.closest('#menu') || panel;
      var trigger = panel.querySelector('[data-mp-meals]') || menuSection;
      var surface = guide.querySelector('[data-mp-box-surface]');
      var message = guide.querySelector('[data-mp-box-message]');
      var countLink = guide.querySelector('[data-mp-box-count]');
      var progress = guide.querySelector('[data-mp-box-progress]');
      var fill = guide.querySelector('[data-mp-box-fill]');
      var marks = Array.prototype.slice.call(guide.querySelectorAll('[data-mp-box-mark]'));
      var dismissers = Array.prototype.slice.call(guide.querySelectorAll('[data-mp-box-dismiss]'));
      var mealIds = new Set(
        Array.prototype.map.call(panel.querySelectorAll('.mp-meal[data-product-id]'), function (card) {
          return card.getAttribute('data-product-id');
        }).filter(Boolean)
      );
      var explain = guide.querySelector('[data-mp-box-explain]');
      var loading = false;
      var queued = false;
      var triggered = false;
      var mode = 'dock';

      function show(nextMode) {
        mode = nextMode === 'intro' ? 'intro' : 'dock';
        guide.hidden = false;
        guide.classList.add('is-visible');
        guide.classList.toggle('is-intro', mode === 'intro');
        guide.classList.toggle('is-docked', mode === 'dock');
        document.documentElement.classList.toggle('mp-box-explaining', mode === 'intro');
        if (explain) explain.setAttribute('aria-expanded', mode === 'intro' ? 'true' : 'false');

        if (surface) {
          surface.setAttribute('role', mode === 'intro' ? 'dialog' : 'region');
          if (mode === 'intro') {
            surface.setAttribute('aria-modal', 'true');
          } else {
            surface.removeAttribute('aria-modal');
          }
        }
      }

      function hide() {
        guide.classList.remove('is-visible');
        guide.hidden = true;
      }

      function collapseToDock() {
        show('dock');
        if (explain) explain.focus({ preventScroll: true });
      }

      function render(count) {
        count = Math.max(0, Number(count) || 0);
        var capped = Math.min(count, 20);
        var next = Math.min(20, Math.max(5, Math.ceil(count / 5) * 5));
        var copy;

        if (count === 0) {
          copy = 'Choose 5 meals to complete your first delivery box.';
        } else if (count > 20) {
          copy = 'You have ' + count + ' meals. One delivery ticket holds a maximum of 20.';
        } else if (count % 5 === 0) {
          copy = count + '-meal box complete. ' + (count === 20 ? 'Your delivery is fully packed.' : 'Check out now or keep building to ' + (count + 5) + '.');
        } else {
          copy = 'Add ' + (next - count) + ' more ' + ((next - count) === 1 ? 'meal' : 'meals') + ' to complete a ' + next + '-meal box.';
        }

        if (message) message.textContent = copy;
        if (countLink) {
          countLink.textContent = count + ' ' + (count === 1 ? 'meal' : 'meals') + ' in cart';
          countLink.setAttribute('aria-label', 'View cart with ' + count + ' ' + (count === 1 ? 'meal' : 'meals'));
        }
        if (progress) {
          progress.setAttribute('aria-valuenow', String(capped));
          progress.setAttribute('aria-valuetext', count + ' eligible ' + (count === 1 ? 'meal' : 'meals') + ' in cart');
        }
        if (fill) fill.style.width = Math.min(100, (capped / 20) * 100) + '%';

        marks.forEach(function (mark) {
          var value = Number(mark.getAttribute('data-mp-box-mark')) || 0;
          mark.classList.toggle('is-reached', count >= value);
          mark.classList.toggle('is-next', count < value && value === next);
        });
        guide.classList.toggle('is-complete', count > 0 && count <= 20 && count % 5 === 0);
        guide.classList.toggle('is-over', count > 20);
      }

      function refresh() {
        if (loading) {
          queued = true;
          return;
        }
        loading = true;
        var rootPath = window.Shopify && Shopify.routes && Shopify.routes.root ? Shopify.routes.root : '/';

        window.fetch(rootPath + 'cart.js', {
          credentials: 'same-origin',
          headers: { Accept: 'application/json' },
          cache: 'no-store'
        })
          .then(function (response) {
            if (!response.ok) throw new Error('Cart could not be read');
            return response.json();
          })
          .then(function (cart) {
            var count = (cart.items || []).reduce(function (total, item) {
              return total + (mealIds.has(String(item.product_id)) ? Number(item.quantity || 0) : 0);
            }, 0);
            render(count);
          })
          .catch(function () {
            if (message) message.textContent = 'Choose meals in groups of five for the most efficient delivery box.';
          })
          .finally(function () {
            loading = false;
            if (queued) {
              queued = false;
              refresh();
            }
          });
      }

      function refreshSoon() {
        window.setTimeout(refresh, 350);
        window.setTimeout(refresh, 1000);
        window.setTimeout(refresh, 2200);
      }

      if (explain) {
        explain.addEventListener('click', function () {
          show('intro');
          var close = guide.querySelector('.mp-box-guide__close');
          if (close) close.focus({ preventScroll: true });
        });
      }

      dismissers.forEach(function (button) {
        button.addEventListener('click', collapseToDock);
      });

      document.addEventListener('keydown', function (event) {
        if (guide.hidden || mode !== 'intro') return;
        if (event.key === 'Escape') {
          event.preventDefault();
          collapseToDock();
        } else if (event.key === 'Tab' && surface) {
          var focusable = Array.prototype.filter.call(surface.querySelectorAll('button:not(:disabled), a[href]'), function (element) { return element.getClientRects().length > 0; });
          var first = focusable[0], last = focusable[focusable.length - 1];
          if (first && event.shiftKey && (document.activeElement === first || !surface.contains(document.activeElement))) {
            event.preventDefault();
            last.focus();
          } else if (last && !event.shiftKey && (document.activeElement === last || !surface.contains(document.activeElement))) {
            event.preventDefault();
            first.focus();
          }
        }
      });

      document.addEventListener('submit', function (event) {
        var form = event.target;
        if (form && form.matches && form.matches('.mp-meal__form')) refreshSoon();
      }, true);

      ['cart:lines-update', 'cart:updated', 'cart:change', 'product:added'].forEach(function (eventName) {
        document.addEventListener(eventName, refreshSoon);
      });
      window.addEventListener('pageshow', refresh);
      window.addEventListener('focus', refresh);
      document.addEventListener('visibilitychange', function () {
        if (!document.hidden) refresh();
      });

      if ('IntersectionObserver' in window && trigger) {
        var observer = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (entry.target !== trigger) return;

            if (entry.isIntersecting) {
              if (!triggered) {
                triggered = true;
                show('dock');
              } else {
                show(mode);
              }
            } else if (triggered && mode !== 'intro') {
              hide();
            }
          });
        }, { threshold: 0.02, rootMargin: '-35% 0px -45% 0px' });

        observer.observe(trigger);
      } else {
        triggered = true;
        show('dock');
      }

      refresh();
    });
  }

  function modal() {
    var pm = document.querySelector('[data-mp-pm]');
    if (!pm || pm.dataset.mpReady) return;
    pm.dataset.mpReady = '1';

    var elPrice = pm.querySelector('[data-mp-pm-price]');
    var elMedia = pm.querySelector('[data-mp-pm-media]');
    var elTabs  = pm.querySelector('[data-mp-pm-tabs]');
    var elBody  = pm.querySelector('[data-mp-pm-body]');
    var elFoot  = pm.querySelector('[data-mp-pm-foot]');
    var opener  = null;

    function close() {
      pm.hidden = true;
      document.documentElement.style.overflow = '';
      if (opener) opener.focus();
    }

    function show(card) {
      if (!card) return;
      var detail = card.querySelector('.mp-meal__detail');
      var panels = detail ? Array.prototype.slice.call(detail.querySelectorAll('.mp-pm__panel')) : [];
      var img = card.querySelector('.mp-meal__media img');
      var form = card.querySelector('.mp-meal__form');
      var title = card.querySelector('.mp-meal__title');
      var price = card.querySelector('.mp-meal__price');
      var elTitle = pm.querySelector('[data-mp-pm-title]');

      if (elTitle) elTitle.textContent = title ? title.textContent.trim() : '';
      elPrice.textContent = price ? price.textContent.trim() : '';

      elMedia.innerHTML = '';
      if (img) {
        var copy = img.cloneNode(false);
        copy.removeAttribute('loading');
        copy.removeAttribute('sizes');
        copy.alt = '';
        elMedia.appendChild(copy);
      }

      elFoot.innerHTML = '';
      if (form) elFoot.appendChild(form.cloneNode(true));

      elTabs.innerHTML = '';
      elBody.innerHTML = '';

      panels.forEach(function (p, i) {
        var tab = document.createElement('button');
        tab.type = 'button';
        tab.className = 'mp-pm__tab' + (i === 0 ? ' is-active' : '');
        tab.setAttribute('role', 'tab');
        tab.setAttribute('aria-selected', i === 0 ? 'true' : 'false');
        tab.textContent = p.getAttribute('data-label') || 'Details';
        elTabs.appendChild(tab);

        var pane = p.cloneNode(true);
        pane.hidden = i !== 0;
        elBody.appendChild(pane);

        tab.addEventListener('click', function () {
          var all = elTabs.querySelectorAll('.mp-pm__tab');
          for (var j = 0; j < all.length; j++) {
            var on = all[j] === tab;
            all[j].classList.toggle('is-active', on);
            all[j].setAttribute('aria-selected', on ? 'true' : 'false');
            if (elBody.children[j]) elBody.children[j].hidden = !on;
          }
        });
      });

      pm.hidden = false;
      document.documentElement.style.overflow = 'hidden';
      var x = pm.querySelector('.mp-pm__x');
      if (x) x.focus();
    }

    document.addEventListener('click', function (e) {
      var more = e.target.closest('[data-mp-more]');
      if (more) { opener = more; show(more.closest('.mp-meal')); return; }
      if (e.target.closest('[data-mp-pm-close]')) close();
    });

    document.addEventListener('keydown', function (e) {
      if (pm.hidden) return;
      if (e.key === 'Escape') { close(); return; }
      if (e.key !== 'Tab') return;

      var focusable = Array.prototype.slice.call(pm.querySelectorAll(
        'a[href], area[href], button, input, select, textarea, [tabindex], [contenteditable="true"]'
      )).filter(function (el) {
        return el.tabIndex >= 0 && !el.matches(':disabled')
          && !el.closest('[hidden], [inert]') && el.getClientRects().length > 0
          && window.getComputedStyle(el).visibility === 'visible';
      });

      if (!focusable.length) {
        e.preventDefault();
        var dialog = pm.querySelector('.mp-pm__card');
        if (dialog) { dialog.setAttribute('tabindex', '-1'); dialog.focus(); }
        return;
      }

      var first = focusable[0];
      var last = focusable[focusable.length - 1];
      var active = document.activeElement;
      if (focusable.indexOf(active) === -1 || (e.shiftKey ? active === first : active === last)) {
        e.preventDefault();
        (e.shiftKey ? last : first).focus();
      }
    });
  }

  function boot() { filters(); modal(); boxGuide(); }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (e) { filters(e.target); modal(); boxGuide(e.target); });
})();

